import React, { ReactNode } from 'react';
import { useForm, FormProvider, DefaultValues, UseFormReturn } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

interface HookFormWrapperProps<T extends Record<string, any>> {
  initialValues: DefaultValues<T> | undefined;
  mode?: 'onBlur' | 'onChange' | 'onSubmit' | 'all' | 'onTouched';
  validationSchema?: yup.ObjectSchema<any>;
  onSubmit: (data: T) => void | Promise<void>;
  children: ReactNode | ((options: UseFormReturn<T>) => ReactNode);
  className?: string;
}

export function HookFormWrapper<T extends Record<string, any>>({
  initialValues,
  validationSchema,
  onSubmit,
  children,
  className,
  mode = 'onBlur',
}: HookFormWrapperProps<T>) {

  const options: UseFormReturn<T> = useForm<T>({
    defaultValues: initialValues,
    ...(validationSchema && { resolver: yupResolver(validationSchema) }),
    mode,
  });

  const handleSubmit = async (data: T) => {
    try {
      await onSubmit(data);
    } catch (error) {
      console.error('Form submission error:', error);
    }
  };

  return (
    <FormProvider {...options}>
      <form
        onSubmit={options.handleSubmit(handleSubmit)}
        className={className}
        noValidate
      >
        {typeof children === 'function' ? children(options) : children}
      </form>
    </FormProvider>
  );
}
